<nz-form-label [attr.nzFor]="formFieldInfo.fieldCode" [hidden]="hideTitle" nzNoColon>
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control [formGroup]="formGroup">
    <nz-space>
        <nz-date-picker style="width:100%" [id]="formFieldInfo.fieldCode" nzPlaceHolder="Định dạng nhập yyyy-MM-dd"
        [nzDisabled]="formFieldInfo.isReadonly" nzSize="large" nzFormat="yyyy-MM-dd" [nzDisabledDate]="disabledDates"
        [formControlName]="formFieldInfo.fieldCode" [(ngModel)]="value" (ngModelChange)="modelChange()">
        </nz-date-picker>
    </nz-space>

</nz-form-control>